import { ListColumn, ListDataColumn } from "../ListColumn";
import { MedicinalProductsListView } from "./MedicinalProductsListView";

export class OwnedEVMPDEntitiesListView extends MedicinalProductsListView {
    constructor(items: any) {

        const itemFinderArrayColumns = [
            new ListColumn("Num", ListDataColumn.TEXT, "num"),
            new ListColumn("Entity", ListDataColumn.TEXT, "entity"),
            new ListColumn("Article 57 Format", ListDataColumn.TEXT, "art57"),
            new ListColumn("Type", ListDataColumn.TEXT, "type"),
            new ListColumn("Status", ListDataColumn.TEXT, "status"),
            new ListColumn("Number", ListDataColumn.NUMBER, "count"),
        ];
        super(items, itemFinderArrayColumns, []);
    }
}